import { createSelector } from '@ngrx/store';

import { AppStates } from '@shared/store/state/app.states';

import * as fromShelfInventoryRequestResponseState from './shelf-inventory-request.reducers';

const selectShelfInventoryRequestState = (state: AppStates) => state.shelfInventoryRequest;

export const selectAllShelfInventoryRequestList = createSelector(
  selectShelfInventoryRequestState,
  fromShelfInventoryRequestResponseState.selectAll
);

export const selectShelfInventoryRequestList = createSelector(
  selectShelfInventoryRequestState,
  (state: fromShelfInventoryRequestResponseState.ShelfInventoryRequestState) => state
);

export const selectShelfInventoryRequestListCriteria = createSelector(selectShelfInventoryRequestState, state => {
  return state.criteriaObject;
});

export const selectShelfInventoryRequestById = createSelector(
  selectShelfInventoryRequestState,
  (state: fromShelfInventoryRequestResponseState.ShelfInventoryRequestState) => state.selected
);

export const selectShelfInventoryRequestHistory = createSelector(
  selectShelfInventoryRequestState,
  (state: fromShelfInventoryRequestResponseState.ShelfInventoryRequestState) => state.auditLogs
);

export const selectShelfInventoryDeleteStatus = createSelector(
  selectShelfInventoryRequestState,
  (state: fromShelfInventoryRequestResponseState.ShelfInventoryRequestState) => {
    return state.isDeleteSuccess;
  }
);
